/**
 * Русское склонение существительного по числу.
 * Формы передаются в порядке: 1 день / 2 дня / 5 дней.
 *
 * Правила: оканчивается на 1 (кроме 11) — первая форма; на 2-4 (кроме 12-14) —
 * вторая; во всех остальных случаях — третья.
 */
export const pluralizeRu = (count, one, few, many) => {
  const absCount = Math.abs(count) % 100;
  const lastDigit = absCount % 10;

  if (absCount > 10 && absCount < 20) return many;
  if (lastDigit === 1) return one;
  if (lastDigit >= 2 && lastDigit <= 4) return few;
  return many;
};

// Частый случай — дни (премиум): «1 день», «3 дня», «7 дней»
export const pluralizeDays = (days) => pluralizeRu(days, 'день', 'дня', 'дней');
